import { render } from "./TemplateBuild.vue?vue&type=template&id=77cad64f&scoped=true"
import script from "./TemplateBuild.vue?vue&type=script&lang=js"
export * from "./TemplateBuild.vue?vue&type=script&lang=js"

import "./TemplateBuild.vue?vue&type=style&index=0&id=77cad64f&lang=scss&scoped=true"

import exportComponent from "/var/www/kl_keepjoy_work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77cad64f"]])

export default __exports__